import React, { useEffect, useState } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import './arvo.less';
import { useScrollHeader } from '../../../hooks';

export default function Arvo({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)

  const newsData = [
    {
      title: '温州医科大学附属眼视光医院＆集视医疗战略合作签约',
      date: '2024-10-31',
      desc: '2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室…',
      img: '/images/news/news1.png',
      route: '/newsInfo/contract'
    },
    {
      title: '集视医疗弱视方案临床试验初步访视结果出炉，001号患者4周基本治愈！',
      date: '2024-10-11',
      desc: '苏州集视医疗科技有限公司（以下简称“集视医疗”）于国内由复旦大学附属眼耳鼻喉科医院牵头，联合多中心开展的全球首个“基于AR技术的全年龄段弱视治疗方案的有效性和安全性”的前瞻性…',
      img: '/images/news/news2.png',
      route: '/newsInfo/amblyopiaClinical'
    },
    {
      title: '集视医疗亮相中华医学会第二十八次眼科学术大会',
      date: '2024-09-04',
      desc: '2024年9月4-8日，中华医学会第二十八次眼科学术大会在武汉国际博览中心隆重举行，作为年度眼科行业最盛大的学术会议，全球逾万名专家、学者相聚于此，交流分享眼科和视觉科学方面最新研究成果…',
      img: '/images/news/news3.png',
      route: '/newsInfo/academic'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / ARVO 2017新兴趋势和热点话题丨双眼增强现实范式用于成人弱视治疗</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2024.08</span>
              </div>
              <div className="article_titleBottom">ARVO 2017新兴趋势和热点话题丨双眼增强现实范式用于成人弱视治疗</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                复旦大学附属眼耳鼻喉科医院眼科孙兴怀教授、刘红主任、文雯博士与美国加州大学的李响博士合作，将增强现实和双眼训练相结合，研发了一种双眼分视的训练新模式并用于成年弱视，
                训练模式包括一个带有双镜头的头戴式显示器和处理器，该双镜头实时捕捉环境图像，经处理器处理后分别投射到双眼前的显示屏上，其中弱视眼和健眼接受的图像对比度不同，
                并且双眼图像信息完整性不一（如下图）。患者佩戴该显示器后进行正常生活工作，需要整合双眼信息后才可以完成日常视觉任务从而达到弱视眼的视觉训练。经过四周左右的训练，
                大部分患者的弱视眼视力和不良的双眼间抑制均有所改善。该研究的初步结果（A dichoptic augmented-reality paradigm as a treatment for adult amblyopes）在2017年ARVO作大会发言交流，
                并被ARVO评为热点（Hot Topic）之一。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/arvo1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                视觉系统由出生到成熟需要经历漫长的发育过程，婴儿出生时，视力不及人的1%，随着年龄的不断增长，
                双眼视细胞不断发育和完善。6岁以内是视功能发育的重要时期，如这个时期某种原因造成双眼视物障碍，
                婴幼儿被迫接受异常的视觉输入，导致视觉通路的发育异常，弱视便会发生。
                <br />
                <br />
                由于弱视是视觉发育相关疾病，因此弱视的治疗与年龄相关，年龄越小，疗效越好，传统观念认为错过视觉
                敏感期（12岁以下）的弱视患者疗效较差，可能造成终生视觉缺陷。然而，无论患者的年龄大小都应当进行治疗。
                <br />
                <br />
                弱视临床治疗”金标准“——遮盖疗法已有200余年历史，迄今为止依旧被认为是最有效的弱视治疗手段，
                但其仍存在诸多弊端，如：依从性不佳、易回退、用于大龄青少年和成人弱视治疗几乎无效等。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/arvo2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                遮盖疗法的原理是通过遮盖优势眼从而强迫弱视眼使用，一般认为传统的遮盖治疗对成人弱视患者无效，但是最新生理学研究提示成人大脑仍具有可塑性。
                这明显与目前成人弱视治疗几乎无效不相符。近年来一系列研究提示单眼弱视的原发病因不再是双眼同视功能异常（binocular dysfunction），
                即弱视患者患弱视眼的视力障碍是继发于异常的双眼间抑制（interocular suppression）。目前常用的遮盖疗法或单眼知觉学习均旨在重塑弱视眼视路而忽略了作为原发因素的不良双眼交互作用，
                这有可能是传统治疗方法效果回退或不能达到视力完全康复的主要原因，因此解除弱视患者的眼间抑制，帮助弱视眼建立视觉解析能力可能是治疗成人单眼弱视的关键因素。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/invest'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/contract'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/invest'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/contract'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PreA_right">
        <div className="PreA_marginMobile">
          <div className='PreA_right-searchBlock flex_row flex_ai-c'>
            <div className='of_hidden' style={{ width: '100%' }}>
              <input
                className="PreA_input flex_full"
                style={{ width: '100%' }}
                type="text"
                // value={demand}
                // onChange={(e) => setDemand(e.target.value)}
                placeholder="搜索文章"
              />
              <div className='PreA_input-line'></div>
            </div>
            <img
              className='PreA_right-icon flex_auto'
              src='/images/news/right.png'
              alt=''
            />
          </div>
          <div className="article_rightType">
            <div className='fz_18 fw_500 lh_21'>文章分类</div>
            <div className="article_rightType-block">
              <div className='PreA_right-item flex_center'>公司资讯</div>
              <div className='PreA_right-item flex_center'>最新资讯</div>
            </div>
          </div>
          <div className="article_rightMore">
            <div className='fz_18 fw_500 lh_21'>更多资讯</div>
            <div className="mt_16">
              <div className="of_hidden">
                <div className='article_rightMoreBlock flex_col'>
                  {newsData.map((item, index) => <div
                    key={index}
                    className='article_rightItem cur_p'
                    onClick={(() => navigate(item.route))}
                  >
                    <div className="article_rightItemBlock">
                      <div className='PreA_right-itemImg flex_center'>
                        <img
                          style={{ width: '100%' }}
                          src={item.img}
                          alt=''
                        />
                      </div>
                      <div className='article_rightItem-date c_85899E flex_row flex_jc-sb'>
                        <div>{item.date}</div>
                        <div className='article_rightItem-type'>最新资讯</div>
                      </div>
                      <div className='article_rightItem-title of_ellipsis'>{item.title}</div>
                      <div className='article_rightItem-desc multiline-ellipsis-2'>{item.desc}</div>
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
            <div className="PreA_right-btnBlock">
              <div
                className='PreA_right-btn flex_row flex_jc-c flex_ai-c'
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={(() => navigate('/companyNews'))}
              >
                全部资讯
                <img
                  class="PreA_right-arrow"
                  alt=""
                  src={hovered ? '/images/home/arrow-right-whiteLine.png' : '/images/home/arrow-right-blackLine.png'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
}
